/** @jsxImportSource @emotion/react */

import { useTranslation } from "react-i18next";

import { PrivacyStyle } from "./style.index";

const Privacy = () => {
  const { t } = useTranslation("privacy");
  return (
    <div css={PrivacyStyle.index}>
      <h1>{t("header")}</h1>
      <p>{t("content.intro")}</p>

      <h2>{t("content.definitions")}</h2>
      <p>{t("content.definition_list.account")}</p>
      <ul>
        <li>
          <strong>“Account“</strong> {t("content.definition_list.account")}
        </li>
        <li>
          <strong>“Games“</strong> {t("content.definition_list.games")}
        </li>
        <li>
          <strong>“Software“</strong> {t("content.definition_list.software")}
        </li>
        <li>
          <strong>“Device(s)“</strong> {t("content.definition_list.devices")}
        </li>
        <li>
          <strong>“Services“</strong> {t("content.definition_list.services")}
        </li>
      </ul>

      <h2>{t("content.use_website")}</h2>
      <ol>
        <li>
          {t("content.rules.age")}
          <ul>
            <li>{t("content.rules.age_conditions.condition1")}</li>
            <li>{t("content.rules.age_conditions.condition2")}</li>
          </ul>
        </li>
        <li>
          {t("content.rules.restrictions")}
          <ul>
            <li>{t("content.rules.restrictions_list.suspend")}</li>
            <li>{t("content.rules.restrictions_list.report")}</li>
          </ul>
        </li>
        <li>
          {t("content.rules.acceptance")}
          <ul>
            <li>{t("content.rules.acceptance_conditions.age")}</li>
            <li>{t("content.rules.acceptance_conditions.understand")}</li>
            <li>{t("content.rules.acceptance_conditions.agreement")}</li>
          </ul>
        </li>
        <li>{t("content.rules.transfer_restriction")}</li>
      </ol>

      <h2>{t("modification")}</h2>
      <ol>
        <li>{t("modification_right")}</li>
        <li>{t("modification_responsibility")}</li>
      </ol>

      <h2>{t("intellectual_property")}</h2>
      <ol>
        <li>{t("intellectual_property_ownership")}</li>
        <li>{t("intellectual_property_restriction")}</li>
        <li>{t("intellectual_property_protection")}</li>
      </ol>

      <h2>{t("conditions_of_use")}</h2>
      <p>{t("conditions_of_use_intro")}</p>
      <ul>
        {Array.from({ length: 16 }, (_, i) => (
          <li key={i}>{t(`conditions_of_use_${i + 1}`)}</li>
        ))}
      </ul>
      <h2>{t("registration_membership")}</h2>
      <p>{t("registration_membership_intro")}</p>
      <p>{t("registration_membership_conditions")}</p>

      <h3>{t("account_registration")}</h3>
      <p>{t("account_registration_desc")}</p>

      <h3>{t("accurate_information")}</h3>
      <p>{t("accurate_information_desc")}</p>

      <h3>{t("data_confidentiality")}</h3>
      <p>{t("data_confidentiality_desc")}</p>

      <h3>{t("personal_data_protection")}</h3>
      <p>{t("personal_data_protection_desc")}</p>

      <h3>{t("verification_process")}</h3>
      <p>{t("verification_process_desc")}</p>

      <h3>{t("security_checks")}</h3>
      <p>{t("security_checks_desc")}</p>

      <h2>{t("placement_of_bets")}</h2>

      <h3>{t("betting_rules")}</h3>
      <p>{t("betting_rules_desc")}</p>

      <h3>{t("right_to_decline_bets")}</h3>
      <p>{t("right_to_decline_bets_desc")}</p>

      <h3>{t("internet_betting_only")}</h3>
      <p>{t("internet_betting_only_desc")}</p>

      <h3>{t("account_suspension")}</h3>
      <p>{t("account_suspension_desc")}</p>

      <h3>{t("abnormal_bets")}</h3>
      <p>{t("abnormal_bets_desc")}</p>
      <h3>{t("ownership")}</h3>
      <p>{t("ownership_desc")}</p>

      <h3>{t("licence_grant")}</h3>
      <p>{t("licence_grant_desc")}</p>

      <h3>{t("purpose")}</h3>
      <p>{t("purpose_desc")}</p>

      <h3>{t("restrictions")}</h3>
      <ul>
        <li>{t("restrictions_list_1")}</li>
        <li>{t("restrictions_list_2")}</li>
        <li>{t("restrictions_list_3")}</li>
        <li>{t("restrictions_list_4")}</li>
        <li>{t("restrictions_list_5")}</li>
        <li>{t("restrictions_list_6")}</li>
      </ul>

      <h2>{t("settlement_of_transactions")}</h2>

      <h3>{t("bank_account_verification")}</h3>
      <p>{t("bank_account_verification_desc")}</p>

      <h3>{t("claiming_deposits")}</h3>
      <p>{t("claiming_deposits_desc")}</p>

      <h3>{t("minimum_transaction_amount")}</h3>
      <p>{t("minimum_transaction_amount_desc")}</p>

      <h3>{t("erroneous_credits")}</h3>
      <p>{t("erroneous_credits_desc")}</p>

      <h2>{t("collection_of_winnings")}</h2>

      <h3>{t("credit_of_winnings")}</h3>
      <p>{t("credit_of_winnings_desc")}</p>

      <h3>{t("playthrough_requirement")}</h3>
      <p>{t("playthrough_requirement_desc")}</p>

      <h3>{t("currency_of_withdrawal")}</h3>
      <p>{t("currency_of_withdrawal_desc")}</p>

      <h3>{t("matching_bank_account")}</h3>
      <p>{t("matching_bank_account_desc")}</p>

      <h3>{t("transaction_fees")}</h3>
      <p>{t("transaction_fees_desc")}</p>
      <h3>{t("multiple_accounts")}</h3>
      <p>{t("multiple_accounts_desc")}</p>

      <h3>{t("turnover_calculation")}</h3>
      <p>{t("turnover_calculation_desc")}</p>

      <h3>{t("valid_turnover")}</h3>
      <p>{t("valid_turnover_desc")}</p>

      <h3>{t("promotion_turnover_exclusion")}</h3>
      <p>{t("promotion_turnover_exclusion_desc")}</p>

      <h3>{t("promotion_modification")}</h3>
      <p>{t("promotion_modification_desc")}</p>

      <h3>{t("suspension_or_withdrawal")}</h3>
      <p>{t("suspension_or_withdrawal_desc")}</p>

      <h3>{t("abuse_prevention")}</h3>
      <p>{t("abuse_prevention_desc")}</p>

      <h3>{t("fraudulent_activities")}</h3>
      <p>{t("fraudulent_activities_desc")}</p>

      <h2>{t("promotional_abuse")}</h2>

      <h3>{t("zero_tolerance_policy")}</h3>
      <p>{t("zero_tolerance_policy_desc")}</p>

      <h3>{t("transaction_review")}</h3>
      <p>{t("transaction_review_desc")}</p>
      <ul>
        <li>{t("transaction_review_list_1")}</li>
        <li>{t("transaction_review_list_2")}</li>
        <li>{t("transaction_review_list_3")}</li>
      </ul>

      <h2>{t("indemnity")}</h2>
      <p>{t("indemnity_desc")}</p>
      <h2>{t("disclaimer")}</h2>

      <h3>{t("third_party_liability")}</h3>
      <p>{t("third_party_liability_desc")}</p>

      <h3>{t("user_discretion_risk")}</h3>
      <p>{t("user_discretion_risk_desc")}</p>

      <h3>{t("jurisdictional_compliance")}</h3>
      <p>{t("jurisdictional_compliance_desc")}</p>

      <h3>{t("limitation_liability")}</h3>
      <p>{t("limitation_liability_desc")}</p>

      <h3>{t("service_expectations")}</h3>
      <p>{t("service_expectations_desc")}</p>

      <h3>{t("game_results_authority")}</h3>
      <p>{t("game_results_authority_desc")}</p>

      <h3>{t("service_modifications")}</h3>
      <p>{t("service_modifications_desc")}</p>

      <h3>{t("superseding_disclaimer")}</h3>
      <p>{t("superseding_disclaimer_desc")}</p>

      <h3>{t("acceptance_terms")}</h3>
      <p>{t("acceptance_terms_desc")}</p>

      <h2>{t("cancellation_termination")}</h2>

      <h3>{t("account_termination")}</h3>
      <p>{t("account_termination_desc")}</p>
      <ul>
        <li>{t("account_termination_list_1")}</li>
        <li>{t("account_termination_list_2")}</li>
        <li>{t("account_termination_list_3")}</li>
        <li>{t("account_termination_list_4")}</li>
        <li>{t("account_termination_list_5")}</li>
        <li>{t("account_termination_list_6")}</li>
        <li>{t("account_termination_list_7")}</li>
        <li>{t("account_termination_list_8")}</li>
        <li>{t("account_termination_list_9")}</li>
        <li>{t("account_termination_list_10")}</li>
        <li>{t("account_termination_list_11")}</li>
      </ul>

      <h3>{t("reactivation_account")}</h3>
      <p>{t("reactivation_account_desc")}</p>

      <h3>{t("authority_over_accounts")}</h3>
      <p>{t("authority_over_accounts_desc")}</p>
      <h2>{t("external_websites")}</h2>

      <h3>{t("external_website_links")}</h3>
      <p>{t("external_website_links_desc")}</p>

      <h3>{t("privacy_practices")}</h3>
      <p>{t("privacy_practices_desc")}</p>

      <h3>{t("liability_disclaimer")}</h3>
      <p>{t("liability_disclaimer_desc")}</p>

      <h3>{t("non_affiliation")}</h3>
      <p>{t("non_affiliation_desc")}</p>

      <h2>{t("adding_discontinuing_games")}</h2>
      <p>{t("adding_discontinuing_games_desc")}</p>

      <h2>{t("violation_terms_conditions")}</h2>

      <h3>{t("enforcement_terms")}</h3>
      <p>{t("enforcement_terms_desc")}</p>

      <h3>{t("indemnification")}</h3>
      <p>{t("indemnification_desc")}</p>
      <ul>
        <li>{t("indemnification_list_1")}</li>
        <li>{t("indemnification_list_2")}</li>
        <li>{t("indemnification_list_3")}</li>
      </ul>

      <h2>{t("miscellaneous")}</h2>

      <h3>{t("agreement_language")}</h3>
      <p>{t("agreement_language_desc")}</p>

      <h3>{t("entire_agreement")}</h3>
      <p>{t("entire_agreement_desc")}</p>
    </div>
  );
};

export default Privacy;
